import React from "react";

export default function Toast({ toast, onClose }) {
  if (!toast?.message) {
    return null;
  }

  return (
    <div className={`toast ${toast.type || "info"}`} role="status" onClick={onClose}>
      {toast.message}
    </div>
  );
}
